import http from 'config/http'
import { notifyToast } from './responseUtils'

export const handleStripe = async (userId, priceId, subId = null, quantity = null, mode = null) => {
  try {
    const token = localStorage.getItem('session')
    const checkoutSession = await http.post(
      `${window.location.origin}/api/checkout-sessions`,
      {
        userId,
        priceId,
        subId,
        quantity,
        mode,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    )

    if (checkoutSession.status >= 400) {
      console.error(checkoutSession.data.error || 'An error occurred')
      return
    }

    // Redirect to Checkout using the session URL provided by the backend.
    window.location.href = checkoutSession.data.url
  } catch (error) {
    console.error('Stripe Error:', error)
    notifyToast('error', 'Stripe Error, please try again later!')
  }
}
